import mutations from "./mutations";
import * as queries from "./queries";
export default {
  queries,
  mutations,
};
